import {useQuery} from "@tanstack/react-query";
import {useEffect, useState} from "react";
import {getRetailLocations} from "../services/RetailLocationService";
import {useLogout} from "./useLogout";

export function useRetailLocations(
    page,
    size,
    businessUnitCode,
    active,
    selectFitEbsCodeIds,
    selectFitCategoryIds,
    filterColumn,
    filterValue,
    filterOperator,
    searchString,
    enabled = true
) {
    const [result, setResult] = useState([]);
    const [totalCount, setTotalCount] = useState(0);

    const logout = useLogout();

    const {data, isError, error, refetch} = useQuery({
        queryKey: [
            "retailLocations",
            page,
            size,
            businessUnitCode,
            active,
            selectFitEbsCodeIds,
            selectFitCategoryIds,
            filterColumn,
            filterValue,
            filterOperator,
            searchString,
        ],
        queryFn: () =>
            getRetailLocations(
                page,
                size,
                {
                    businessUnitCode,
                    active,
                    selectFitEbsCodeIds,
                    selectFitCategoryIds,
                    filterColumn,
                    filterValue,
                    filterOperator,
                    searchString,
                }
            ),
        enabled: enabled,
        retry: false,
    });

    useEffect(() => {
        if (isError && error.response && error.response.status) {
            if (error.response.status === 401) {
                logout();
            }
        }
    }, [isError, error]);

    useEffect(() => {
        if (data) {
            setResult(data.retailLocations);
            setTotalCount(data.totalCount);
        }
    }, [data]);

    return [result, totalCount, refetch];
}
